import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, " To get an API KEY you need to register new OPEN API account and then visit "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://platform.openai.com/account/api-keys",
    target: "_blank"
  }, " https://platform.openai.com/account/api-keys ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputAPIKey = _resolveComponent("InputAPIKey")!
  const _component_Accordeon = _resolveComponent("Accordeon")!

  return (_openBlock(), _createBlock(_component_Accordeon, {
    title: "Set API KEY",
    value: _ctx.apiKeyVisible,
    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apiKeyVisible) = $event)),
    class: "mt-8 api-key"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_InputAPIKey, {
        value: _ctx.value,
        class: "w-3/4 mt-4",
        useLocalStorage: true,
        "onUpdate:value": _cache[0] || (_cache[0] = (val) => _ctx.$emit('update:value', val)),
        placeholder: "Paste a key here"
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["value"]))
}